export default __webpack_public_path__ + "static/media/download-invoice-logo.c7d97112.svg";